<template>
  <div class="mb-3">
    <b-table
      :class="`text-center table-${variant} mb-0`"
      striped
      responsive
      show-empty
      :empty-text="$lang.notRecordExist"
      :fields="fields"
      :items="items"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    variant: {
      type: String,
      default: "default",
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    fields() {
      return [
        {
          key: "score0",
          label: "ردیف",
          class: "text-center",
          thClass: "p-2 border-0 bg-secondary",
          tdClass: "p-2 text-left",
        },
        {
          key: "score1",
          label: "حوزه",
          class: "text-center",
          thClass: "p-2 border-0 bg-secondary",
          tdClass: "p-2 text-left",
        },
        {
          key: "score2",
          label: "وضعیت",
          class: "text-center",
          thClass: "p-2 border-0 bg-secondary",
          tdClass: "p-2 text-left",
        },
        {
          key: "score3",
          label: "آخرین قبولی",
          class: "text-center",
          thClass: "p-2 border-0 bg-secondary",
          tdClass: "p-2 text-left",
        },
      ];
    },
  },
};
</script>


<style lang="scss" scoped>
.table-info {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #63c2de1a !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
.table-success {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #4dbd741a !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
.table-primary {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #007bff1a !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
.table-danger {
  tbody {
    tr:nth-of-type(odd) {
      background-color: #ffb6be8c !important;
    }
    tr:nth-of-type(even) {
      background-color: #ffffff80 !important;
    }
  }
}
</style>
